import { _ as t } from "./_baseToString.B41tpU4a.js";
var n = t;
function o(r) {
  return r == null ? "" : n(r);
}
var a = o;
export {
  a as t
};
//# sourceMappingURL=toString.Cx3TcJvA.js.map
